import { Injectable, } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { catchError } from 'rxjs/operators';
import { ErrorService } from '../../error.service';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { NgZone } from '@angular/core';
import { AuthenticationRequestBo } from './login.modal';

@Injectable({
    providedIn: 'root'
})

export class LoginService {
    httpOptions = {
        headers: new HttpHeaders({
            "Content-Type": "application/json",
        })
    };
    constructor(private http: HttpClient, public errorService: ErrorService, public zone: NgZone) { }
    CheckLoginAuthentication(saveLogin: AuthenticationRequestBo): Observable<any> {
        let url = "api/Auth/login?";
        return this.http.post<any>(url, saveLogin, { observe: 'response' }).pipe(
            map(data => data.body),
            catchError(this.errorService.handleError)
        )
    }
    getSideMenus(): Observable<any> {
        var url = "api/Auth/GetSideMenus";
        return this.http.get<any>(url, { observe: 'response' }).pipe(map(data => data.body),
            catchError(this.errorService.handleError));
    }
    getWebsiteUserDetails(): Observable<any> {
        var url = "api/Auth/getWebsiteUserDetails?";
        return this.http.get<any>(url, { observe: 'response' }).pipe(map(data => data.body),
            catchError(this.errorService.handleError));
    }
}